import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-in-vitro-fertilization',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './in-vitro-fertilization.component.html',
  styleUrl: './in-vitro-fertilization.component.scss'
})
export class InVitroFertilizationComponent implements OnInit {

  constructor(private route: Router, private metaService: Meta, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title,) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/in-vitro-fertilization",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);



    this.titleService.setTitle('Best In Vitro Fertilization (IVF) Treatment in Kannur | Ncare IVF Centre');
    this.metaService.updateTag({
      name: 'description',
      content: 'Advanced In Vitro Fertilization (IVF) treatment at Ncare IVF Center in Kannur. Our expert fertility specialists offer personalized care to help couples achieve successful pregnancy outcomes.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'IVF Treatment in Kannur, IVF Treatment in Kerala, IVF Treatment Center, In Vitro Fertilization, IVF Treatment, IVF Treatment Center in Kannur,  In Vitro Fertilization in Kannur'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Best In Vitro Fertilization (IVF) Treatment in Kannur | Ncare IVF Centre'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Advanced In Vitro Fertilization (IVF) treatment at Ncare IVF Center in Kannur. Our expert fertility specialists offer personalized care to help couples achieve successful pregnancy outcomes.'
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
